import { useState, useEffect } from 'react';
import axios from 'axios';
import { URL } from './Constants';

export default function useFetch<T>(endpoint: string) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(URL + endpoint)
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
      });
  }, [endpoint]);

  return { data, loading, error };
}
